(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (()=>{const header=document.querySelector('[data-tsd-header]');if(!header)return;const button=header.querySelector('[data-tsd-menu-button]');const menu=header.querySelector('[data-tsd-mobile-menu]');if(button&&menu)button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));menu.hidden=open});header.querySelectorAll('.tsd-nav__drop').forEach(item=>item.addEventListener('toggle',()=>{if(item.open)header.querySelectorAll('.tsd-nav__drop').forEach(other=>{if(other!==item)other.removeAttribute('open')})}));document.addEventListener('click',event=>{if(!header.contains(event.target))header.querySelectorAll('details[open]').forEach(item=>item.removeAttribute('open'))})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsd-product-experience"]) return;
  try {
    
  (()=>{const root=document.querySelector('.prod-product-template');if(!root)return;const quick=document.querySelector('[data-tsd-product-quick]');const target=root.querySelector('.product__section-details');if(quick&&target)target.appendChild(quick);const proof=document.querySelector('.tsd-product-proof');const firstClear=Array.from(root.children).find(child=>child.classList.contains('clear'));if(proof&&firstClear)root.insertBefore(proof,firstClear);const reviews=root.querySelector('#product-reviews');const look=document.querySelector('.tsd-product-look');const info=document.querySelector('.tsd-product-info-grid');if(reviews){if(look)root.insertBefore(look,reviews);if(info)root.insertBefore(info,reviews)}})();

  } catch(e) { console.error(e); }
})();
})();
